import React, { useState } from "react";
import { Send } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";

const STATUS = { sent: "Link inviato, non ancora aperto", opened: "Aperta dal destinatario" };

export const GiftResendButton = ({ orderId, testId }) => {
  const [open, setOpen] = useState(false);
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const show = async () => {
    setOpen(true); setError(""); setInfo(null); setEmail("");
    try { const { data } = await api.get(`/gift/deliveries/${orderId}`); setInfo(data); }
    catch (e) { setError(formatApiErrorDetail(e.response?.data?.detail) || "Stato non disponibile"); }
  };
  const send = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/gift/deliveries/${orderId}/resend`, { email });
      toast.success(`Nuovo link inviato a ${data.recipient_email}. Il link precedente non funziona più.`);
      setOpen(false);
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Invio non riuscito"); }
    finally { setBusy(false); }
  };
  return <>
    <Button variant="ghost" size="icon" className="h-8 w-8 shrink-0" onClick={show} aria-label="Reinvia gift card" title="Reinvia gift card" data-testid={testId}><Send className="w-4 h-4" /></Button>
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent data-testid={`${testId}-dialog`}>
        <DialogHeader><DialogTitle>Reinvia gift card</DialogTitle></DialogHeader>
        {error && <p role="alert" className="text-sm text-destructive" data-testid={`${testId}-error`}>{error}</p>}
        {info && <div className="space-y-3 text-sm">
          <p data-testid={`${testId}-current`}>Inviata a <strong>{info.recipient_email}</strong> · {STATUS[info.status] || info.status}{info.opened_at ? ` il ${new Date(info.opened_at).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" })}` : ""}</p>
          <p className="text-xs text-muted-foreground">Inserisci il nuovo indirizzo: creiamo un nuovo link e quello precedente smette subito di funzionare.</p>
          <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="nuovo indirizzo email" data-testid={`${testId}-email`} />
        </div>}
        <DialogFooter><Button variant="ghost" onClick={() => setOpen(false)} data-testid={`${testId}-cancel`}>Annulla</Button>{info && <Button onClick={send} disabled={busy || !/^\S+@\S+\.\S+$/.test(email)} data-testid={`${testId}-send`}>{busy ? "Invio…" : "Invia nuovo link"}</Button>}</DialogFooter>
      </DialogContent>
    </Dialog>
  </>;
};
